import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import Manipulator from '../../utils/dom/manipulator';
import Request from '../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';

class EditRole {
	constructor() {
		this.schoolsList = [];
		this._container = SelectorEngine.findOne('.js-edit-coach-details-role');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-coach-details__edit-role-form', this._container);

		this._exitModal = new Modal(SelectorEngine.findOne('#coach-details-role-exit'), {});

		this._cancelCta = SelectorEngine.findOne('.lta-coach-details__edit-role-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-coach-details__edit-role-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-coach-details__edit-role-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._errorContainer = SelectorEngine.findOne('.lta-edit-role-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this.fv = attachValidation(this._form, {
			role: {
				validators: {
					notEmpty: {
						message: 'Please select an option'
					}
				}
			}
		});
		this.fv.on('core.form.valid', () => {
			this.submitEnquiry(this._form);
		});
	}

	async submitEnquiry(form) {
		stopLoadingAnimation();

		const dataObject = getDataFromForm(form);
		const payload = {
			updateCoachDetailsRequest: {
				role: dataObject.role
			}
		};

		try {
			const url = `/api/coachdetails/update`;
			const responseData = await Request.post(url, payload);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			startLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditRole = new EditRole();

export default globalEditRole;
